export default "__VITE_ASSET__NBi8P1eK__"